import { FormAtylBase } from '../../form-atyl-base'

export class AtylTable extends FormAtylBase<string>{
	controlType = 'table'
	type: string
	key: string
	minRow: number
	options: any
	optionsDefault: any
	rows: any[]
	rowControlers: any[] = [];
	nameColumns: string[]
	idColumns: string[]

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.key = options['key'] || []
		this.minRow = options['minRow'] || []
		this.options = options['options'] || []
		this.optionsDefault = options['optionsDefault'] || []
		this.nameColumns = []
		this.idColumns = []
	}


}
